import { mergeFilters, toggleReduxSliceFiltersVisibility } from "@helpers/reduxHelpers.js";
import { createSlice } from "@reduxjs/toolkit";
import FILTERS_KEYS from "@utils/filters_keys.js";
import { REHYDRATE } from "redux-persist/es/constants";

const defaultFilters = [
	{ id: FILTERS_KEYS.stock.client, name: "stocks:clientsFilter", visible: false },
	{ id: FILTERS_KEYS.stock.distributor, name: "stocks:distributorsFilter", visible: false },
	{ id: FILTERS_KEYS.stock.businessUnits, name: "stocks:businessUnitFilter", visible: false },
	{ id: FILTERS_KEYS.stock.status, name: "stocks:statusFilter", visible: false },
];
const initialState = {
	data: null,
	filters: [...defaultFilters],
	loading: false,
	customers: [],
	vessels: [],

	selectedClient: "",
	selectedVessel: "",
	setAction: "",

	pagination: {
		page: 1,
		perPage: 10,
		totalItems: 0,
		totalPage: 0,
	},
};

const stockSlice = createSlice({
	name: "auth/user",
	initialState,
	reducers: {
		setStockData: (state, action) => {
			state.data = action.payload.data;
			state.pagination.totalItems = action.payload.totalItems;
			state.pagination.page = action.payload.page;
			state.pagination.perPage = action.payload.perPage;
			state.pagination.totalPage = Math.ceil(action.payload.totalItems / action.payload.perPage);
		},
		setLoadingStock: (state, action) => {
			state.loading = action.payload;
		},

		setCustomers: (state, action) => {
			// if (!state.customers) {
			//   state.customers = [];
			// }
			state.customers = action.payload;
		},
		setVessels: (state, action) => {
			if (!state.vessels) {
				state.vessels = [];
			}
			state.vessels = action.payload;
		},
		setLoadingVessels: (state, action) => {
			state.vessels.loading = action.payload;
		},

		setAssignaction: (state, action) => {
			const { client, vessel, setaction } = action.payload;
			state.selectedClient = client;
			state.selectedVessel = vessel;
			state.setAction = setaction;
		},

		setDeassignaction: (state, action) => {
			const { client, setaction } = action.payload;
			state.selectedClient = client;
			state.setAction = setaction;
		},
		toggleStockFilterVisibility: toggleReduxSliceFiltersVisibility,
	},
	extraReducers: (builder) => {
		builder.addCase(REHYDRATE, (state, action) => {
			// Get persisted filters
			const persistedFilters = action.payload?.modules?.stock?.filters ?? null;
			// Merge filters with persisted state
			state.filters = mergeFilters(persistedFilters, defaultFilters);
		});
	},
});

export const {
	setStockData,
	setLoadingStock,
	setCustomers,
	setVessels,
	setLoadingVessels,
	setAssignaction,
	setDeassignaction,
	toggleStockFilterVisibility,
} = stockSlice.actions;
export default stockSlice.reducer;
